import { SignalType } from '../types/signal-type.js';

export const DIGITAL_BANDWIDTH_OPTIONS: readonly number[] = [
  2, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50,
];
export const ANALOG_BANDWIDTH_OPTIONS: readonly number[] = [2, 5, 10, 15, 20];

export const DEFAULT_MANUAL_BANDWIDTH_MHZ = 10;

/**
 * Fallback multi-frequency defaults, used when a device's multi-frequency setting is absent — the
 * zahrada rollout window, and skeleton / unresolved-profile devices. Each matches zahrada's own
 * default for its setting, so a device that has not reported one yet seeds what it will report.
 * Analog for the signal type: zahrada's default for the kvitka family.
 */
export const DEFAULT_ANALOG_MULTI_FREQUENCY_BANDWIDTH_MHZ = 5;
export const DEFAULT_DIGITAL_MULTI_FREQUENCY_BANDWIDTH_MHZ = 5;
export const DEFAULT_MULTI_FREQUENCY_SIGNAL_TYPE = SignalType.ANALOG;

/**
 * Granularity of every MHz frequency input, in MHz (10 Hz). Not merely a stepper increment: the
 * browser's own stepMismatch check blocks a form's submit event while the zod schema still reports
 * the value valid, so a coarser step leaves an enabled button that does nothing in-app and
 * surfaces only a native validation bubble.
 */
export const FREQUENCY_STEP_MHZ = 0.00001;

// Mirror the backend export limits; the backend stays authoritative and re-checks both.
export const SUPPRESSIONS_EXPORT_MAX_DEVICES = 100;
export const SUPPRESSIONS_EXPORT_MAX_RANGE_DAYS = 31;
export const SUPPRESSIONS_EXPORT_TOO_MANY_ROWS_ERROR_CODE = 'SUPPRESSIONS_EXPORT_TOO_MANY_ROWS';
export const MS_PER_DAY = 86_400_000;
